export default __webpack_public_path__ + "static/media/google-play-badge.6f484bf5.png";